export default __webpack_public_path__ + "img/30.asset.718f6013.jpeg";